import { Grid } from "@material-ui/core";
import React, { useContext } from "react";
import { store } from "../../Context/Store";
import SearchItem from "./SearchItem";

const SearchList = () => {
  const context = useContext(store);
  const { state } = context;

  return (
    <Grid container direction="column" alignItems="center">
      {state.addressResult.map((address, i) => (
        <SearchItem address={address} key={i} />
      ))}
    </Grid>
  );
};

export default SearchList;
